export class DispatchState
{
id:number; 
state : string; 
}